import { IsEnum, IsNotEmpty, IsNumber, IsOptional } from 'class-validator';
import { ApiProperty } from '@nestjs/swagger';
import { CategoryEnum } from '@gtpl/shared-models/masters';
export class DimensionDTO {
    @ApiProperty()
    @IsNotEmpty({ message: "Plant Id should not be empty" })
    @IsNumber()
    plantId: number;

    @ApiProperty({
        enum: CategoryEnum
    })
    @IsNotEmpty({ message: "Category should not be empty" })
    @IsEnum(CategoryEnum)
    category: CategoryEnum;

    @ApiProperty()
    @IsNotEmpty({ message: "Category Id should not be empty" })
    categoryId: string;

    @ApiProperty()
    @IsNotEmpty({ message: "Boundaries should not be empty" })
    boundaries: string;

    @ApiProperty()
    @IsOptional()
    createdUser: string;
}